/// <reference types="vite-plugin-svgr/client" />
"use client";
import React from "react";
import { PropertyTabsProps } from "../types";
import IconPlaces from "/static/img/tabIconPlaces.svg?react";
import IconInfo from "/static/img/tabIconInfo.svg?react";

export const PropertyTabs: React.FC<PropertyTabsProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <section id="PropertyTabs" className="w-full md:w-[450px]">
      <nav className="flex w-full text-sm md:text-md font-semibold leading-none">
        <button id="Property info (button)" aria-current={activeTab === "property" ? "page" : undefined} onClick={() => onTabChange("property")}
          className={`flex justify-center items-center w-1/2 h-full pb-[8px] border-b-white ${activeTab === "property" ? "text-white border-b-[1px]" : "text-border border-b-0"}`}>
          <IconInfo className={`w-[18px] h-[18px] ${ activeTab === "property" ? "fill-white" : "fill-border"}`} />
        </button>
        <button id="Places (button)" aria-current={activeTab === "places" ? "page" : undefined} onClick={() => onTabChange("places")}
          className={`flex justify-center items-center w-1/2 h-full pb-[8px] border-b-white ${activeTab === "places" ? "text-white border-b-[1px]" : "text-border border-b-0"}`}>
          <IconPlaces className={`w-[18px] h-[18px] ${ activeTab === "places" ? "fill-white" : "fill-border"}`} />
        </button>
      </nav>
    </section>
  );
};